/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Maxim Fedorov
 * @version 1.13.0
 * @since 1.0.1
 */

import { PureComponent, RefObject } from 'react';

import RenderInBody from '../../../../modules/app/hoc/RenderInBody';
import { TextBlock } from '../../index';
import { IChartTooltipItem } from './chartPieTypes';
import { ChartTooltipDotStyled, ChartTooltipPercentStyled, ChartTooltipStyled } from './styled/ChartPieStyled';

interface IChartTooltipProps {
    chartRef: RefObject<HTMLDivElement>;
}

interface IChartTooltipState {
    isVisible: boolean;
    item: IChartTooltipItem;
}

class ChartTooltip extends PureComponent<IChartTooltipProps, IChartTooltipState> {

    top = 0;
    left = 0;

    state = {
        isVisible: false,
        item: {
            color: '',
            name: '',
            percent: '',
            value: '',
            x: 0,
            y: 0,
        },
    };

    calcRect = (): void => {
        const chartRef = this.props.chartRef;
        // get the position of chart by Oy and subtract 100 px to place the tooltip under the cursor
        this.top = (chartRef.current?.getBoundingClientRect().top ?? 0) - 100;
        this.left = (chartRef.current?.getBoundingClientRect().left ?? 0);
    };

    render() {
        const {
            isVisible,
            item,
        } = this.state;
        this.calcRect();
        return (
            <RenderInBody>
                {
                    <ChartTooltipStyled
                        style={{
                            top: `${item.y + this.top}px`,
                            left: `${item.x + this.left}px`,
                            opacity: isVisible && !!item.x && !!item.y ? 1 : 0,
                        }}
                    >
                        <ChartTooltipDotStyled color={item.color}/>
                        <TextBlock className="tooltip__name">
                            {item.name}
                        </TextBlock>
                        <TextBlock className="tooltip__value"
                        >
                            {item.value}
                        </TextBlock>
                        <ChartTooltipPercentStyled>
                            ({item.percent})
                        </ChartTooltipPercentStyled>
                    </ChartTooltipStyled>
                }
            </RenderInBody>
        );
    }
}

export default ChartTooltip;
